export const operation = {
    name: 'operation',
    params: {
        searchFields: ['alias', 'name'],
        entityParams: { name: 'operation' },
        getOrderOperationCreationHooks: () => ([ 'create',  'manager_confirm' ])
    }
};
